import { render, staticRenderFns } from "./ClickOverlay.vue?vue&type=template&id=15635e13&scoped=true"
import script from "./ClickOverlay.vue?vue&type=script&lang=js"
export * from "./ClickOverlay.vue?vue&type=script&lang=js"
import style0 from "./ClickOverlay.vue?vue&type=style&index=0&id=15635e13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15635e13",
  null
  
)

export default component.exports